<script>
import _ from "lodash";
import { Btn, Modal, Popover } from "uiv";

export default {
  components: { Btn, Modal, Popover },
  props: {
    url: { type: String, required: true },
    params: { type: Object, required: true },
    disabled: { type: Boolean, required: false, default: false },
    btnSize: { type: String, required: false, default: "" },
    btnType: { type: String, required: false, default: "" },
    customClass: { type: String, required: false, default: "" },
    contentClass: { type: String, required: false, default: "" },

    codigo: { type: String, required: false, default: "" },
    conector: { type: String, required: false, default: "" },
  },
  data() {
    return {
      show: false,
      url_busqueda: this.url,
      identificador: _.uniqueId("url-popover_"),
    };
  },
  created() {
    this.updateURL();
  },
  methods: {
    updateURL() {
      let url = [];
      let params = this.params;

      url.push(this.url);
      url.push("services");
      url.push("circuitos");

      if (params.mes_salida) {
        url.push(`mes:${params.mes_salida}`);
      }

      if (params.ciudad_salida) {
        url.push(`salida:${params.ciudad_salida}`);
      }

      if (params.ciudades.length) {
        url.push(`ciudades:${params.ciudades.join(":")}`);
      }

      if (params.proveedores.length) {
        url.push(`proveedores:${params.proveedores.join(":")}`);
      }

      if (this.conector) {
        url.push(`conector:${this.conector}`);
      }

      if (this.codigo) {
        url.push(`codigo:${this.codigo}`);
      }

      this.url_busqueda = url.join("/");
    },
  },
  watch: {
    params: {
      deep: true,
      handler(params) {
        this.updateURL();
      },
    },
  },
};
</script>

<template>
  <div class="url-popover-comp" :class="contentClass">
    <btn :id="identificador" :disabled="disabled" :size="btnSize" :type="btnType">
      <slot>
        <i class="mdi mdi-open-in-new"></i> URL
      </slot>
    </btn>
    <popover
      title="URL de Busqueda"
      :target="`#${identificador}`"
      placement="left"
      :custom-class="'url-popover '+ customClass"
    >
      <template slot="popover">
        <input type="text" class="form-control" v-model="url_busqueda" />
      </template>
    </popover>
  </div>
</template>
